import React, { useEffect, useContext, useState, useRef } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import {
  Box,
  Container,
  Hidden,
  Button,
  CircularProgress,
} from '@material-ui/core';

import Moment from 'moment'
Moment.locale('fr')

import PopupNotifContext from "../contexts/PopupNotifContext"
import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"

import { FormatSwitch } from "./Formation"
import ScaleThumbForm from "../components/ui/Formation/ScaleThumbForm"

import MyModal from "../components/ui/MyModal"
import CircularGauge from "../components/ui/CircularGauge"

import { GLB_URL_APIS } from "../utils/APIS"
import progressionKeys from "../utils/progressionKeys"

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import nawalAbboubExpert from "../images/nawalAbboubExpert.png";
import cadrillageBGCard from "../images/cadrillageBGCard.svg"
import modulesIcon from "../images/modulesIcon.svg"
import moyenneIcon from "../images/moyenneIcon.svg"
import moyenneTempsIcon from "../images/moyenneTempsIcon.svg"
import tauxCompletionIcon from "../images/tauxCompletionIcon.svg"
import softSkillsIcon from "../images/softSkillsIcon.svg"
import cardIcon from "../images/cardIcon.svg"
import resourcesCard from "../images/resourcesCard.svg"
import closeIcon from '../images/closeIcon.svg';


const SteppedCard = ({ p, setResultModal }) => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { addPopupNotif } = useContext(PopupNotifContext)
  const {
    actPlan,
    actFormation,
  } = useContext(UserContext)

  const myRefContainer = useRef(null)

  useEffect(() => {
    //pour scroll vers la formation actuelle dans "votre programme"
    if (p?.id === actFormation?.id && myRefContainer?.current) {
      myRefContainer.current.scrollIntoView({container:"nearest"})
    }
  }, [actFormation, p, myRefContainer?.current])


  let isDone = p?.isDone

  let button = null
  if (p?.isDone === false && p?.isOpen === true && p?.progress !== false) {
    button = "resume"
  } else if (p?.isDone === false && p?.isOpen === true && p?.progress === false) {
    button = "start"
  } else if (p?.isDone && p.isIcebreaker !== true) {
    button = "results"
  }

  let status = null //completed, inProgress, passed, open, futured
  let statusText = ""
  if (p?.isDone) {
    status = "completed"
  } else {
    if (p?.isOpen === true) {
      //plan ouvert
      if (p?.progress === false) {
        //dispo (xxx jours restants)
        status = "open"
        if (p?.isOpenForRat === true) {
          let currentDay = Moment().startOf('day');
          var closeDate = Moment(p?.closeDateRat, "YYYY-MM-DD");
          let diffClose = parseInt(Moment.duration(closeDate.diff(currentDay)).asDays() + 1);
          if (diffClose <= 1) {
            statusText = languageValues?.dashboard?.stepper?.hoursLeft[actLanguage]
          } else {
            statusText = diffClose + languageValues?.dashboard?.stepper?.daysLeft[actLanguage]
          }
        } else {
          let currentDay = Moment().startOf('day');
          var closeDate = Moment(p?.closeDate, "YYYY-MM-DD");
          let diffClose = parseInt(Moment.duration(closeDate.diff(currentDay)).asDays()) + 1;
          if (diffClose <= 1) {
            statusText = languageValues?.dashboard?.stepper?.hoursLeft[actLanguage]
          } else {
            statusText = diffClose + languageValues?.dashboard?.stepper?.daysLeft[actLanguage]
          }
        }
      } else {
        //en cours (avec % progression)
        status = "inProgress"
      }
    } else {
      //plan fermé
      let currentDay = Moment().startOf('day');
      var normalOpenDate = Moment(p?.openDate, "YYYY-MM-DD");
      let diffNormalOpenDate = Moment.duration(normalOpenDate.diff(currentDay)).asDays();
      if (p?.enableRat === true && diffNormalOpenDate < 0) {
        let current = Moment().startOf('day');
        var openDate = Moment(p?.openDateRat, "YYYY-MM-DD");
        let diffOpen = parseInt(Moment.duration(openDate.diff(current)).asDays());
        var closeDate = Moment(p?.closeDateRat, "YYYY-MM-DD");
        let diffClose = parseInt(Moment.duration(closeDate.diff(current)).asDays());
        if (diffOpen >= 0 && diffClose >= 0) {
          //à venir
          status = "futured"
          statusText = Moment(p.openDateRat).format('DD/MM/YYYY')
        } else {
          //passé
          status = "passed"
        }
      } else {
        let current = Moment().startOf('day');
        var openDate = Moment(p?.openDate, "YYYY-MM-DD");
        let diffOpen = parseInt(Moment.duration(openDate.diff(current)).asDays());
        var closeDate = Moment(p?.closeDate, "YYYY-MM-DD");
        let diffClose = parseInt(Moment.duration(closeDate.diff(current)).asDays());
        if (diffOpen >= 0 && diffClose >= 0) {
          //à venir
          status = "futured"
          statusText = Moment(p.openDate).format('DD/MM/YYYY')
        } else {
          //passé
          status = "passed"
        }
      }
    }
  }

  return (
    <Box ref={myRefContainer} sx={{
      height:["60px", "60px", "120px", "75px"],
      display:"flex",
      flexDirection:["row", "row", "column", "row"],
      flex:1,
      justifyContent:"space-between",
      gap:"15px",
      overflow:"hidden",
    }}>
      <Box sx={{
        display:"flex",
        flexDirection:["row", "row", "column", "row"],
        gap:"15px",
        overflow:"hidden",
      }}>
        <Box sx={{
          display:["block", "block", "flex", "block"],
        }}>
          <Box sx={{
            width:"13px",
            height:"13px",
            border:"1px solid black",
            borderRadius:"50%",
            background:isDone && "black",
          }} />
          <Box sx={{
            display:["none", "none", "block", "none"],
            borderTop:isDone ? "1px solid black" : "1px dashed black",
            width:"100%",
            marginTop:"6px",
            height:"1px",
          }} />
          <Box sx={{
            display:["block", "block", "none", "block"],
            borderLeft:isDone ? "1px solid black" : "1px dashed black",
            width:"1px",
            marginLeft:"6px",
            height:"calc(100% - 13px)",
          }} />
        </Box>
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          gap:"7px",
          overflow:"hidden",
        }}>
          <Box sx={{
            color:"text.black",
            fontSize:["15px", "15px", "15px", "16px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {p?.name}
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["13px", "13px", "13px", "14px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {status === "open" &&
              statusText
            }
            {status === "futured" &&
              statusText
            }
            {status === "passed" &&
              languageValues?.dashboard?.stepper?.closed[actLanguage]
            }
            {status === "completed" &&
              languageValues?.dashboard?.stepper?.completed[actLanguage]
            }
            {status === "inProgress" &&
              <Box sx={{display:"flex", gap:"7px", alignItems:"center"}}>
                <Box sx={{width:"100px", height:"10px", border:"1px solid black", position:"relative"}}>
                  <Box sx={{position:"absolute", background:"black", height:"8px", width:p?.progress+"%"}}>
                  </Box>
                </Box>
                <Box sx={{fontSize:"13px"}}>
                  {p?.progress}%
                </Box>
              </Box>
            }
          </Box>
        </Box>
      </Box>
      <Box>
        {button === "results" &&
          <Button
            onClick={() => {
              setResultModal(p)
            }}
            size="small"
            type="submit"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
              backgroundColor : "background.grey",
              border:"1px solid #EFEFEF",
              color:"text.black",
              "&:hover" : {
                color:"red",
                backgroundColor : "background.grey",
                border:"1px solid #EFEFEF",
                color:"text.subTitle",
              }
            }}
          >
            {languageValues?.dashboard?.stepper?.seeResultsBtn[actLanguage]}
          </Button>
        }
        {button === "start" &&
          <Button
            onClick={() => {
              if (p?.id === actFormation?.id) {
                navigate('/formation')
              } else {
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.notifError[actLanguage],
                  type : "error",
                  removeAfter:5000,
                })
              }
            }}
            size="small"
            type="submit"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
            }}
          >
            {languageValues?.dashboard?.stepper?.startBtn[actLanguage]}
          </Button>
        }
        {button === "resume" &&
          <Button
            onClick={() => {
              if (p?.id === actFormation?.id) {
                navigate('/formation')
              } else {
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.notifError[actLanguage],
                  type : "error",
                  removeAfter:5000,
                })
              }
            }}
            size="small"
            type="submit"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
            }}
          >
            {languageValues?.dashboard?.stepper?.resumeBtn[actLanguage]}
          </Button>
        }
      </Box>
    </Box>
  )
}

const ActFormationButton = ({ setResultModal }) => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const {
    currentUser,
    actPlan,
    actFormation,
  } = useContext(UserContext)

  let status = null
  if (actFormation?.isDone) {
    status = "completed"
  } else {
    if (actFormation?.isOpen === true) {
      //plan ouvert
      if (actFormation?.progress === null || actFormation?.progress === undefined || actFormation?.progress === false) {
        //dispo
        status = "open"
      } else {
        //en cours
        status = "inProgress"
      }
    }
  }


  return (
    <>
      {status === "completed" &&
        <Button
          onClick={() => {
            setResultModal(actFormation)
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            width:["100%", "100%", "unset", "unset"],
            fontSize:"16px",
            whiteSpace:"nowrap",
            paddingLeft:"40px",
            paddingRight:"40px",
            backgroundColor : "background.grey",
            border:"1px solid #EFEFEF",
            color:"text.black",
            "&:hover" : {
              color:"red",
              backgroundColor : "background.grey",
              border:"1px solid #EFEFEF",
              color:"text.subTitle",
            }
          }}
        >
          {languageValues?.dashboard?.stepper?.seeResultsBtn[actLanguage]}
        </Button>
      }
      {status === "inProgress" &&
        <Button
          onClick={() => {
            navigate('/formation')
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            width:["100%", "100%", "unset", "unset"],
            fontSize:"16px",
            whiteSpace:"nowrap",
            paddingLeft:"40px",
            paddingRight:"40px",
          }}
        >
          {languageValues?.dashboard?.stepper?.resumeBtn[actLanguage]}
        </Button>
      }
      {status === "open" &&
        <Button
          onClick={() => {
            navigate('/formation')
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            width:["100%", "100%", "unset", "unset"],
            fontSize:"16px",
            whiteSpace:"nowrap",
            paddingLeft:"40px",
            paddingRight:"40px",
          }}
        >
          {languageValues?.dashboard?.stepper?.startBtn[actLanguage]}
        </Button>
      }
    </>
  )
}

const CardContainer = ({icon, title, value, dataLoaded, unit}) => {
  return (
    <Box
      sx={{
        width:
          [
            "calc((100% / 2) - (((2 - 1) / 2) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 20px))",
          ],
        height: ["102px", "130px", "130px", "145px"],
        minHeight: ["102px", "130px", "130px", "145px"],
        border:"1px solid #E7E7E7",
        backgroundImage:`url(${cadrillageBGCard})`,
        backgroundRepeat:"no-repeat",
        backgroundPosition:"right 5px bottom 5px",
        backgroundColor:"white",
      }}
    >
      <Box sx={{
        width:"100%",
        height:"100%",
        background: "linear-gradient(130deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 95%, rgba(0, 0, 0, 0) 100%)",
      }}>
        {dataLoaded ? (
          <Box sx={{padding:["10px", "15px", "15px", "15px"], display: "flex", flexDirection:"column"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center", marginBottom:["7px", "12px", "12px", "8px"]}}>
              <Box
                sx={{
                  width:["20px", "35px", "35px", "40px"],
                  minWidth:["20px", "35px", "35px", "40px"],
                }}
              >
                <img src={icon} style={{width:"100%"}}/>
              </Box>
              <Box sx={{fontSize:["14px", "16px", "16px", "18px"], color:"text.subTitle", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
                {title}
              </Box>
            </Box>
            <Box sx={{fontSize:["30px", "41px", "41px", "46px"], color:"black", display:"flex", alignItems:"flex-end", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
              {value}
              {unit &&
                <Box sx={{fontSize:["26px", "22px", "22px", "16px"], color:"text.subTitle", paddingBottom:["3px","5px","5px","5px"], whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden"}}>{unit}</Box>
              }
            </Box>
          </Box>
        ) : (
          <Box sx={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <CircularProgress size="30px" sx={{'color': 'black'}} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

const Dashboard = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const {
    currentUser,
    actPlan,
    actFormation,
    actIndex,
    lastDoneIndex,
  } = useContext(UserContext)

  const [myStats, setMyStats] = useState({})

  useEffect(() => {
    if (currentUser && actPlan && actFormation) {
      let newStats = {}
      let actPlanWithoutIcebreaker = [...actPlan]?.slice(1)
      newStats.nbrModules = actPlanWithoutIcebreaker?.length || "-"
      if (actPlanWithoutIcebreaker?.length > 0) {
        let nbrSoftSkills = 0
        let totalTempsPassé = 0
        let nbrModulesDone = 0
        let totalScoreModulesDone = 0
        let nbrModulesMoyGroupe = 0
        let totalModulesMoyGroupe = 0

        let findStartProgression = false
        let findEndProgression = false

        actPlanWithoutIcebreaker.forEach((p) => {
          //nbr softSkills
          if (p?.softSkillsFromContent) {
            nbrSoftSkills += p?.softSkillsFromContent?.length
          }

          //moyenne temps passé
          if (p?.timing >= 0) {
            totalTempsPassé += p?.timing
          }

          //moyenne des modules terminées + progression
          if (p?.isDone && p?.resultFin) {

            //moyenne modules terminées
            nbrModulesDone += 1
            if (p?.resultFin?.glbMaster) {
              totalScoreModulesDone += p?.resultFin?.glbMaster?.score || 0
            } else {
              totalScoreModulesDone += p?.resultFin?.master?.score || 0
            }

            //progression
            if (progressionKeys?.start && progressionKeys?.end) {
              let findStart = Object.keys(p?.resultFin).find((el) => el.includes(progressionKeys?.start))
              if (findStart) {
                findStartProgression = p?.resultFin[findStart]
              }
              let findEnd = Object.keys(p?.resultFin).find((el) => el.includes(progressionKeys?.end))
              if (findEnd) {
                findEndProgression = p?.resultFin[findEnd]
              }
            }
          }

          //moyenne groupe
          if (p?.moyContentForThisGroupe >= 0) {
            nbrModulesMoyGroupe += 1
            totalModulesMoyGroupe += p?.moyContentForThisGroupe
          }
        })

        newStats.nbrSoftSkills = nbrSoftSkills
        newStats.moyTempsPasse = parseInt(totalTempsPassé/newStats.nbrModules)
        //moyenne modules terminées
        newStats.nbrModulesDone = nbrModulesDone
        if (newStats?.nbrModulesDone > 0) {
          newStats.moyModulesDone = parseInt(totalScoreModulesDone/newStats.nbrModulesDone)
        } else {
          newStats.moyModulesDone = "-"
        }
        //progression
        if (findStartProgression && findEndProgression) {
          newStats.progression = parseInt(findEndProgression?.score - findStartProgression?.score)
        }
        //moyenne groupe
        newStats.nbrModulesMoyGroupe = nbrModulesMoyGroupe
        if (newStats?.nbrModulesMoyGroupe > 0) {
          newStats.moyGroupe = parseInt(totalModulesMoyGroupe/newStats.nbrModulesMoyGroupe)
        } else {
          newStats.moyGroupe = "-"
        }
      }

      setMyStats(newStats)
    } else {
      setMyStats({})
    }
  }, [currentUser, actPlan, actFormation])


  const [resultModal, setResultModal] = useState(false)
  const [resultModalName, setResultModalName] = useState("")
  const [resultModalValue, setResultModalValue] = useState(0)
  const [resultModalText, setResultModalText] = useState("")
  useEffect(() => {
    if (resultModal !== false) {
      setResultModalName(resultModal?.name)
      let resultFin = null
      try {
        if (typeof resultModal?.resultFin === "string") {
          resultFin = JSON.parse(resultModal?.resultFin)
        } else if (typeof resultModal?.resultFin === "object") {
          resultFin = resultModal?.resultFin
        }
      } catch(e) { console.log(e) }
      if (resultFin) {
        let scoreToTake = 0
        let chooseCat = ""
        if (resultFin?.glbMaster?.score !== undefined && resultFin?.glbMaster?.score !== null) {
          scoreToTake = resultFin?.glbMaster?.score
          chooseCat = "glbMaster"
        } else if (resultFin?.master?.score !== undefined && resultFin?.master?.score !== null) {
          scoreToTake = resultFin?.master?.score
          chooseCat = "master"
        }
        if (chooseCat !== "") {
          setResultModalValue(scoreToTake)
          //on va cercher dans les seuils pour trouver le texte
          let findInSeuils = resultModal?.seuils?.find((el) => el.key === chooseCat)
          if (findInSeuils) {
            let newText = ""
            for (let i=findInSeuils?.value?.seuil?.length-1; i>=0; i--) {
              if (parseInt(scoreToTake) >= findInSeuils?.value?.seuil[i]?.seuil) {
                newText = findInSeuils?.value?.seuil[i]?.text
              }
            }
            setResultModalText(newText)
          } else {
            setResultModalText("")
          }
        } else {
          setResultModalValue(0)
          setResultModalText("")
        }
      } else {
        setResultModalValue(0)
        setResultModalText("")
      }
    } else {
      setResultModalValue(0)
      setResultModalText("")
    }
  }, [resultModal])



  return (
    <>
      <Helmet>
        <title>Dashboard | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:["20px", "50px", "50px", "80px"],
            backgroundColor:"background.grey",
          }}
        >
          {/* TOP */}
          <Box sx={{
            display:"flex",
            flexDirection:["column", "row"],
            justifyContent:"space-between",
            paddingBottom:["30px","40px","40px","50px"],
            rowGap:"15px",
            columnGap:"30px",
            alignItems:["flex-start","center"],
            overflow:"hidden",
          }}>
            <Box sx={{
              overflow:"hidden",
              maxWidth:"100%"
            }}>
              <Box sx={{
                fontSize:["26px","36px","36px","42px"],
                color:"text.black",
                paddingTop:["10px", "12px", "12px", "15px"],
                paddingBottom:["10px", "12px", "12px", "15px"],
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {languageValues?.adminDashboard?.homeWelcome[actLanguage]}{currentUser?.name?.split(" ")[0]},
              </Box>
              <Box sx={{
                fontSize:["15px","19px","19px","22px"],
                color:"text.black",
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {languageValues?.adminDashboard?.homeWelcomeSub[actLanguage]}
              </Box>
            </Box>
            {currentUser?.groupes[0]?.img ? (
              <Box sx={{
                display:"flex",
                flexDirection:["row", "column"],
                rowGap:"15px",
                columnGap:"15px",
                overflow:"hidden",
                maxWidth:"100%",
              }}>
                <Hidden smDown>
                  <img src={GLB_URL_APIS+"/groupesLogos/"+currentUser?.groupes[0]?.img} style={{maxHeight:"60px", objectFit:"contain"}} />
                </Hidden>
                <Hidden smUp>
                  <img src={GLB_URL_APIS+"/groupesLogos/"+currentUser?.groupes[0]?.img} style={{maxHeight:"50px", objectFit:"contain"}} />
                </Hidden>
              </Box>
            ) : (
              <Box sx={{
                display:"flex",
                flexDirection:["row", "column"],
                rowGap:"15px",
                columnGap:"15px",
                overflow:"hidden",
                maxWidth:"100%",
              }}>
                <Hidden smDown>
                  <img src="/static/logo.png" style={{maxHeight:"60px", maxWidth:"200px", objectFit:"contain"}} />
                </Hidden>
                <Hidden smUp>
                  <img src="/static/logo.png" style={{maxHeight:"50px", maxWidth:"150px", objectFit:"contain"}} />
                </Hidden>
              </Box>
            )}
          </Box>
          {/* END TOP */}

          {/* ACT FORMATION & PLANS */}
          <Box sx={{
            paddingBottom:["25px","30px","30px","40px"],
            display:"flex",
            flexDirection:["column", "column", "column", "row"],
            columnGap:"35px",
            rowGap:["15px", "20px"],
            maxHeight:["unset", "unset", "unset", "407px"],
            overflow:"hidden",
          }}>
            <Box sx={{
              flex:0.65,
              border:"1px solid #E7E7E7",
              background:"white",
              padding:["10px", "15px", "15px", "20px"],
              display:"flex",
              flexDirection:["column", "column", "column", "row"],
              columnGap:"30px",
              rowGap:["15px", "20px"],
              overflow:"hidden",
            }}>
              <Box sx={{
                flex:0.6,
                height:"325px",
                minHeight:["200px", "380px", "380px", "325px"],
                overflow:"hidden",
                display:"flex",
                justifyContent:"center",
                alignItems:"center",
              }}>
                <Box sx={{
                  aspectRatio:"1.5",
                  overflow:"hidden",
                  maxHeight:"100%"
                }}>
                  <ScaleThumbForm onClick={actFormation?.isOpen ? () => { navigate('/formation') } : null}>
                    <FormatSwitch
                      actFormation={actFormation}
                      format={actFormation?.chapitre[lastDoneIndex?.chapitre]?.partie[lastDoneIndex?.partie]?.sequence[lastDoneIndex?.sequence]}
                      actIndex={{chapitre : lastDoneIndex?.chapitre, partie : lastDoneIndex?.partie, sequence : lastDoneIndex?.sequence}}
                      actPlan={actPlan}
                      onlyContent
                    />
                  </ScaleThumbForm>
                </Box>
              </Box>
              <Box sx={{
                flex:0.4,
                overflow:"hidden",
                display:"flex",
                columnGap:"20px",
                flexDirection:["column", "column", "row", "column"],
                justifyContent:["center", "center", "space-between", "center"],
                padding:["10px", "5px 10px", "15px 20px", "0px"],
              }}>
                <Box sx={{overflow:"hidden"}}>
                  <Box sx={{
                    fontSize:["22px", "22px", "28px", "32px"],
                    color:"text.black",
                    marginBottom:"10px",
                    whiteSpace:"noWrap",
                    textOverflow:"ellipsis",
                    overflow:"hidden",
                  }}>
                    {actFormation?.name}
                  </Box>
                  <Box sx={{
                    fontSize:["15px", "15px", "18px", "20px"],
                    color:"text.black",
                    whiteSpace:"noWrap",
                    textOverflow:"ellipsis",
                    overflow:"hidden",
                    paddingBottom:"20px",
                    borderBottom:["1px solid #EFEFEF", "1px solid #EFEFEF", "0", "1px solid #EFEFEF"],
                  }}>
                    {actFormation?.description}
                  </Box>
                  <Box sx={{
                    display:["none", "none", "block", "none"],
                    marginTop:"30px",
                  }}>
                    <ActFormationButton setResultModal={setResultModal}/>
                  </Box>
                </Box>
                <Box sx={{
                  display:"flex",
                  gap:"12px",
                  marginTop:["20px", "20px", "0px", "20px"],
                }}>
                  <Box sx={{
                    width:["40px", "40px", "50px", "50px"],
                    height:["40px", "40px", "50px", "50px"],
                  }}>
                    <img src={nawalAbboubExpert} style={{width:"100%", height:"100%"}} />
                  </Box>
                  <Box sx={{
                    display:"flex",
                    flexDirection:"column",
                    gap:"5px",
                    justifyContent:"center",
                  }}>
                    <Box sx={{
                      fontSize:"15px",
                      color:"text.black",
                      whiteSpace:"noWrap",
                    }}>
                      Nawal Abboub
                    </Box>
                    <Box sx={{
                      fontSize:"13px",
                      color:"text.subTitle",
                      whiteSpace:"noWrap",
                    }}>
                      {languageValues?.dashboard?.expertDesc[actLanguage]}
                    </Box>
                  </Box>
                </Box>
                <Box sx={{
                  display:["block", "block", "none", "block"],
                  marginTop:"40px",
                }}>
                  <ActFormationButton setResultModal={setResultModal}/>
                </Box>
              </Box>
            </Box>
            <Box sx={{
              flex:0.35,
              border:"1px solid #E7E7E7",
              background:"white",
              padding:["15px 10px", "20px 15px", "30px 20px", "25px 20px"],
              paddingBottom:["0 !important", "0 !important", "30px !important", "0 !important"],
              overflow:"hidden",
            }}>
              <Box sx={{
                color:"text.black",
                fontSize:["22px", "24px", "24px", "26px"],
                paddingBottom:["10px", "15px", "30px", "15px"],
              }}>
                {languageValues?.dashboard?.yourProgram[actLanguage]}
              </Box>
              <Box sx={{
                overflowX:"hidden",
                overflowY:"auto",
                maxHeight:["240px", "240px", "190px", "calc(100% - 40px)"],
                paddingLeft:["10px", "0px", "0px", "10px"],
                paddingRight:["10px", "0px", "0px", "10px"],
                display:["block", "block", "flex", "block"]
              }}>
                <SteppedCard p={{name : "Icebreaker", isDone:true, isIcebreaker:true}}/>
                {actPlan?.slice(1)?.map((p, key) => {
                  return (
                    <SteppedCard key={key} p={p} setResultModal={setResultModal}/>
                  )
                })}
              </Box>
            </Box>
          </Box>
          {/* END ACT FORMATION & PLANS */}

          {/* MY STATS */}
          <Box sx={{
            display:"flex",
            gap:"40px",
            paddingTop:"10px",
          }}>
            <Hidden lgDown>
              <Box sx={{
                flex:0.25,
                display:"flex",
                flexDirection:"column",
                gap:"30px",
              }}>
                <Box sx={{
                  fontSize:["22px", "22px", "26px", "32px"],
                  color:"text.black",
                }}>
                  {languageValues?.dashboard?.resources[actLanguage]}
                </Box>
                <Box
                  sx={{
                    border:"1px solid #E7E7E7",
                    background:"white",
                    flex:1,
                    padding:"25px",
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center",
                    justifyContent:"center",
                    gap:"10px"
                  }}
                >
                  <img src={resourcesCard} style={{width:"100%", maxWidth:"310px", marginBottom:"20px"}}/>
                  <Box sx={{
                    color:"text.black",
                    fontSize:"26px",
                    width:"100%",
                  }}>
                    {languageValues?.dashboard?.resourcesCard?.title[actLanguage]}
                  </Box>
                  <Box sx={{display:"flex", width:"100%", marginTop:"10px", justifyContent:"space-around", flexWrap:"wrap", columnGap:"20px"}}>
                    <Button
                      variant="text"
                      onClick={() => {
                        window.open("https://www.risinguparis.com/soft-skills", '_blank').focus();
                      }}
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:0,
                        fontSize:"18px",
                        whiteSpace:"noWrap",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        }
                      }}
                    >
                      {languageValues?.dashboard?.resourcesCard?.dictionary[actLanguage]}
                      <KeyboardArrowDownIcon style={{transform:"rotate(-90deg)",marginBottom:"2px"}}/>
                    </Button>
                    <Button
                      variant="text"
                      onClick={() => {
                        window.open("https://www.risinguparis.com/blog", '_blank').focus();
                      }}
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:0,
                        fontSize:"18px",
                        whiteSpace:"noWrap",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        }
                      }}
                    >
                      Blog
                      <KeyboardArrowDownIcon style={{transform:"rotate(-90deg)",marginBottom:"2px"}}/>
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Hidden>
            <Box sx={{
              flex:[1, 1, 1, 0.75],
              display:"flex",
              flexDirection:"column",
              gap:["15px", "20px", "20px", "30px"]
            }}>
              <Box sx={{
                fontSize:["22px", "22px", "26px", "32px"],
                color:"text.black",
              }}>
                {languageValues?.dashboard?.myStats[actLanguage]}
              </Box>
              <Box sx={{display:"flex", flexWrap:"wrap", gap:["15px","15px","15px","20px"]}}>
                <CardContainer
                  title={languageValues?.dashboard?.cards?.modulesAverage[actLanguage]}
                  value={myStats?.moyModulesDone!==undefined?myStats.moyModulesDone:"-"} icon={cardIcon} dataLoaded={true} unit="&nbsp;/100"
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.modules[actLanguage]}
                  value={myStats?.nbrModules!==undefined?myStats.nbrModules:"-"} icon={modulesIcon} dataLoaded={true}
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.progression[actLanguage]}
                  value={myStats?.progression!==undefined?myStats.progression:"-"} icon={tauxCompletionIcon} dataLoaded={true} unit="&nbsp;/100"
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.groupeAverage[actLanguage]}
                  value={myStats?.moyGroupe!==undefined?myStats.moyGroupe:"-"} icon={moyenneIcon} dataLoaded={true} unit="&nbsp;/100"
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.softSkills[actLanguage]}
                  value={myStats?.nbrSoftSkills!==undefined?myStats.nbrSoftSkills:"-"} icon={softSkillsIcon} dataLoaded={true}
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.time[actLanguage]}
                  value={myStats?.moyTempsPasse!==undefined?myStats.moyTempsPasse:"-"} icon={moyenneTempsIcon} dataLoaded={true} unit="&nbsp;MIN"
                />
              </Box>
            </Box>
          </Box>
          {/* END MY STATS */}


          {/* LB MY RESULTS */}
            <MyModal
              isOpen={resultModal!==false}
              maxWidth="md"
              onClose={() => { setResultModal(false) }}
              fullCustom
              forMyResults
            >
              <Box>
                <Box sx={{
                  display:"flex",
                  justifyContent:"flex-end"
                }}>
                  <img
                    src={closeIcon}
                    style={{width:"17px", height:"17px", cursor:"pointer"}}
                    onClick={() => { setResultModal(false) }}
                  />
                </Box>

                <Box sx={{
                  display:"flex",
                  flexDirection:["column", "column", "row", "row"],
                  justifyContent:"space-between",
                  alignItems:["center", "center", "stretch", "stretch"],
                  columnGap:"110px",
                  rowGap:"35px",
                  padding:"10px 20px"
                }}>
                  <Box sx={{
                    order:[1, 1, 0, 0],
                    display:"flex",
                    flexDirection:"column",
                    //justifyContent:"space-between"
                  }}>
                    <Box sx={{
                      textAlign:["center", "center", "left", "left"],
                    }}>
                      <Box sx={{
                        color:"text.black",
                        fontSize:"18px",
                      }}>
                        {resultModalName}
                      </Box>
                      <Box sx={{
                        color:"text.black",
                        fontSize:["32px", "36px", "42px", "42px"],
                        marginTop:"5px",
                        marginBottom:["20px", "30px", "40px", "40px"]
                      }}>
                        {languageValues?.dashboard?.resultModal?.title[actLanguage]}
                      </Box>
                    </Box>
                    <Box sx={{
                      color:"text.subTitle",
                      fontSize:["15px", "16px", "18px", "18px"],
                      maxWidth:"500px",
                      textAlign:["center", "center", "left", "left"],
                    }}>
                      {resultModalText}
                    </Box>
                  </Box>
                  <Box>
                    <Box sx={{
                      width:["250px", "275px", "32px", "320px"],
                      height:["250px", "275px", "320px", "320px"],
                      display:"flex",
                      alignItems:"center",
                      justifyContent:"center"
                    }}>
                      <Hidden smDown>
                        <CircularGauge value={resultModalValue} size={275} />
                      </Hidden>
                      <Hidden smUp>
                        <CircularGauge value={resultModalValue} size={250} />
                      </Hidden>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </MyModal>
          {/* END LB MY RESULTS */}
        </Box>
      </Box>
    </>
  )
};

export default Dashboard;
